import { PDFDocument } from 'pdf-lib';

/**
 * Merge a results sheet PDF (prepended) with the student's answer sheet PDF.
 * Mirrors students-app/services/pdfMergeService.ts
 */
export const mergeResultsWithAnswerSheet = async (resultsSheetBytes, answerSheetBytes) => {
  const resultsDoc = await PDFDocument.load(resultsSheetBytes);
  const answerDoc = await PDFDocument.load(answerSheetBytes);
  const mergedDoc = await PDFDocument.create();

  const resultsPages = await mergedDoc.copyPages(resultsDoc, resultsDoc.getPageIndices());
  resultsPages.forEach((page) => mergedDoc.addPage(page));

  const answerPages = await mergedDoc.copyPages(answerDoc, answerDoc.getPageIndices());
  answerPages.forEach((page) => mergedDoc.addPage(page));

  return mergedDoc.save();
};
